import React from 'react'
import { PushButton } from '../pushbutton/PushButton'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import "./marketing.css"


export const TestsStats = () => {

    const {
       
        changeTestLanguage,
      
    } = React.useContext(StatusContext);

     const {
        collegeStats,
        getUniversityStats,
        getButtonsClicksCount
      
    } = React.useContext(AITestContext);

    const [university, setUniversity] = React.useState("University of Belgrade");
    const [buttonClicks, setButtonClicks] = React.useState([]);
    const [clickStatsLoading, setClickStatsLoading] = React.useState(false);
    const [clickStatsError, setClickStatsError] = React.useState("");
    const [showClickStats, setShowClickStats] = React.useState(false);

    const handleUniversityChange = (event) => {
    setUniversity(event.target.value);
  };

    const handleUniversityPayment = async () => {

      getUniversityStats(university)

    }

     const handleGetButtonClicks = async () => {
    if (clickStatsLoading) return;

    setClickStatsLoading(true);
    setClickStatsError("");

      const data = await getButtonsClicksCount()

      if (!Array.isArray(data)) {
        throw new Error("The server did not return an array of button clicks.");
      }

      setButtonClicks(data);
      setShowClickStats(true);
      setClickStatsLoading(false);
    
  };


   
  return (

    <div className="homeContainer">
       
       <label style={{fontWeight:'500', fontSize:'22px'}}>College tests payments</label>
        <br/>
        <br/>
       <table className="stats-table">
          <tbody>
            <tr>
              <th scope="row" style={{textAlign:'center'}}>
                Select university
              </th>
              
              <td>
                  <select
                      id="universitySelect"
                      value={university}
                      onChange={handleUniversityChange}
                      style={{
                        border: "none",
                        outline: "none",
                        backgroundColor: "transparent",
                      }}
                    >
                    <option value="University of Belgrade">
                      University of Belgrade
                    </option>

                    <option value="University of Rome">
                      University of Rome
                    </option>
                  </select>
              </td>

              <td><PushButton onClick={handleUniversityPayment} label =  "Refresh"/></td>
            </tr>

          </tbody>
        </table>
        <br/>
        <br/>

      < table className="stats-table">
        <thead>
          <tr>
            <th>College</th>
            <th>
              {changeTestLanguage("aitest", "individualtests")}
            </th>
            <th>
              {changeTestLanguage("aitest", "schoolyeartests")}
            </th>
          </tr>
        </thead>

        <tbody>
          {collegeStats.map((stat) => (
            <tr key={stat.college}>
              <td style={{textAlign:'center'}}>{stat.college}</td>
              <td>{stat.individualtests}</td>
              <td>{stat.schoolyeartests}</td>
            </tr>
          ))}
        </tbody>
      </table>


       {/* Button-click statistics */}

       <br/>
      <section aria-busy={clickStatsLoading}>
        <h2 style={{ fontWeight: "500", fontSize: "22px" }}>
          Button click statistics
        </h2>

        <PushButton
          onClick={handleGetButtonClicks}
          label={clickStatsLoading ? "Loading..." : "Refresh button clicks"}
        />

        {clickStatsError && (
          <p role="alert" style={{ color: "red" }}>
            {clickStatsError}
          </p>
        )}

          {showClickStats && (
          <table
            className="stats-table"
            style={{ marginTop: "20px" }}
          >
            <thead>
              <tr>
                <th scope="col">Button</th>
                <th scope="col">Click count</th>
              </tr>
            </thead>

              <tbody>
              {buttonClicks.length > 0 ? (
                buttonClicks.map((button) => (
                  <tr key={button.button_id}>
                    <td style={{ textAlign: "center" }}>
                      {button.test_button}
                    </td>
                    <td>{button.click_count}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} style={{ textAlign: "center" }}>
                    No button clicks found.
                  </td>
                </tr>
              )}

                  </tbody>
          </table>
        )}
      </section>

       <div style={{ height: "200px" }} />

    </div>
  )
}


